module.exports = __webpack_public_path__ + "static/img/image1_new.f4ec8e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image1_new.jpg
// module id = zkPY
// module chunks = 0